import axios from "axios";
import LocalStorageService from "@/common/LocalStorageService";
import router from "@/router";
import Vue from 'vue'

const localStorageService = LocalStorageService.getService();

export const registerService = {
    getProfile() {
        return new Promise(resolve => {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/has-profile`).then(response => {
                const profile = response.data;
                resolve(profile);
            });
        })
    },

    refreshToken(minValidity) {
        return new Promise((resolve, reject) => {
            Vue.prototype.$keycloak.updateToken(minValidity).success(function () {
                localStorageService.setAuthTokens(Vue.prototype.$keycloak);
                resolve();
            }).error(function () {
                this.$log.error('Failed to refresh token' );
                localStorageService.clearAuthTokens();
                router.push('/timeout');
                reject();
            });
        });
    }
}